"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_1_ = _interopRequireDefault(require("../images/help_1_2.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var combat = {
  id: "combat",
  title: {
    en: "Lesson 2 (Combat)",
    de: "Lektion 2 (Kampf)"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_1_.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#EFF3BD"
      }
    }, "When you are familiar with moving and selecting, then I will explain about the battile."), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "When you first starting out, look for easy pray to hunt. They are placed around the entrances to the Rog's royal palace."), /*#__PURE__*/_react.default.createElement("li", null, "When you select a target the target's HP and difficulty level will appear in graphics at the top center of your screen. Difficulty level will be indicated in white, blue system. They are good to battle"), /*#__PURE__*/_react.default.createElement("li", null, "You can select a target by 1click and if you click once more or press short key Q you will attack.")), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#EFF3BD"
      }
    }, "When you are victorious"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "When you defeat the NPC after the battle you can earn experience points, and you can loot item(s) or money from the corps.", /*#__PURE__*/_react.default.createElement("p", {
      style: {
        color: "#BC6E13"
      }
    }, "Reference) Looting: Looting is what you do when you looking for an item or money from corps. In order to loot a corp(s) you have to have the right to loot, in order to obtain those rights it depends on how much you contribute on your battle. In case of party battle, all party members can loot.")), /*#__PURE__*/_react.default.createElement("li", null, "When you kill your enemy, click on the body and the looting window will appear. Money will automatically transfer to you, and for the items, choose the item(s) you desire and move them to your inventory. While you are on the looting window, R-clicking on the item(s) will automatically put the items in your inventory.")), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#EFF3BD"
      }
    }, "If you are defeated after the battle"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "When you find your HP is lower than the NPC HP, and you figure there is nothing much to gain, then press F1key to do quick retreat from the battle.", /*#__PURE__*/_react.default.createElement("p", {
      style: {
        color: "#BC6E13"
      }
    }, "Reference) When you are in quick retreat you will loose SP in large quantity. Remember that when you want to escape quick retreat is the best way. Make sure to keep your eye on your SP.")), /*#__PURE__*/_react.default.createElement("li", null, "In case of death from an unavoidable battle, either wait for a cleric class character to revive you or type /revive at the chatting window and start from your last bind stone.")))
  }
};
var _default = combat;
exports.default = _default;